import m from "../../geodata/es2015/hondurasLow";
window.am4geodata_hondurasLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/hondurasLow.js
// module id = null
// module chunks = 